// extracted by mini-css-extract-plugin
module.exports = {"information":"PictoAndTextList_information__2kXZ8"};